import type { SVGProps } from 'react';

export const Filters = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="13.2px"
    role="img"
    viewBox="0 0 19 13.2"
    width="19px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'filters'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-751, -188.8)">
        <g transform="translate(727, 174)">
          <g transform="translate(24, 12.6)">
            <rect height="17.6" width="19" x="0" y="0" />
            <g fill="#898C9A" transform="translate(0, 2.2)">
              <path d="M18.109375,0 C18.6012536,0 19,0.492486775 19,1.1 C19,1.67177715 18.6467852,2.14166236 18.1951481,2.19496451 C18.1379783,2.19832078 18.0807224,2.2 18.0234542,2.2 L0.890625,2.2 L0.890625,2.2 C0.398746395,2.2 0,1.70751322 0,1.1 C0,0.528222847 0.353214799,0.058337636 0.804851869,0.00503549058 C0.862021665,0.00167921843 0.919277583,4.54609213e-16 0.976545814,0 L18.109375,0 L18.109375,0 Z M15.0706779,5.5 C15.6011872,5.5 16.03125,5.99248678 16.03125,6.6 C16.03125,7.17177715 15.6502947,7.64166236 15.1631874,7.69496451 C15.1015258,7.69832088 15.0397843,7.7 14.9780314,7.7 L3.92932211,7.7 L3.92932211,7.7 C3.39881278,7.7 2.96875,7.20751322 2.96875,6.6 C2.96875,6.02822285 3.34970527,5.55833764 3.83681261,5.50503549 C3.89847421,5.50167912 3.96021568,5.5 4.02196857,5.5 L15.0706779,5.5 L15.0706779,5.5 Z M11.8480114,11 C12.5187549,11 13.0625,11.4924868 13.0625,12.1 C13.0625,12.6717772 12.5808435,13.1416624 11.9649747,13.1949645 C11.8870082,13.1983211 11.8089784,13.2 11.7309397,13.2 L7.15198864,13.2 L7.15198864,13.2 C6.48124508,13.2 5.9375,12.7075132 5.9375,12.1 C5.9375,11.5282228 6.41915654,11.0583376 7.03502528,11.0050355 C7.11299183,11.0016789 7.19102157,11 7.26906034,11 L11.8480114,11 L11.8480114,11 Z" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
